@if (!inputService.hidden && inputService.formInputDefinition && inputService.control) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field [appearance]='inputService.inputConfig.appearence'>
      <mat-label>
        @if (inputService.exportEAgency) {
          <img matTooltip='Esportato in eAgency' class='title-input-eagency' src='assets/images/logos/logo_eagency.png'/>
        }
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      <!--<mat-hint *ngIf='inputService.inputConfig.hint'>{{inputService.inputConfig.hint}}</mat-hint>-->
      @if (inputService.inputConfig.readOnly) {
        <input matInput readonly type='text' [value]='selectedLabel' [required]='inputService.inputConfig.required'/>
      }
      @if (!inputService.inputConfig.readOnly) {
        <mat-select (selectionChange)="selectionChange($event)"
          [required]='inputService.inputConfig.required'
          [placeholder]="inputService.inputConfig.placeholder | translate"
          [formControlName]='inputService.formControlKey'>
          @for (selectOption of selectOptions; track selectOption) {
            @if (selectOption && !selectOption.group) {
              <mat-option [value]='selectOption.value'>
                <span [innerHTML]='selectOption.label | titlecase'></span>
              </mat-option>
            }
            <!-- grouped options -->
            @if (selectOption && selectOption.group && selectOption.group.length > 0) {
              <mat-optgroup [label]="selectOption.label">
                @for (option of selectOption.group; track option) {
                  <mat-option [value]='option.value'>
                    <span [innerHTML]='option.label | titlecase'></span>
                  </mat-option>
                }
              </mat-optgroup>
            }
          }
        </mat-select>
      }
      @if (!inputService.inputConfig.readOnly && !inputService.formInputDefinition.disallowNull && inputService.inputConfig.clearable && inputService.control.value) {
        <mat-icon matSuffix style='cursor: pointer;' (click)='inputService.control.setValue(null)'>close</mat-icon>
      }
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint | translate}}</mat-hint>
      }
      @if (!inputService.control.valid) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}